export function getQueryFromUrl(query) {
  const urlParamMatch = window.location.search.match(new RegExp(`(^|[?&])${query}=([^&]+)`))
  return urlParamMatch ? urlParamMatch[2] : null
}

export function getPathFromUrl(url) {
  return url.split(document.body.dataset.locale)[1]
}
